import React from 'react';

// Painel da tela de login: o Quality no centro, ligado aos módulos (integração com o IW,
// captação, pacientes, equipes, indicadores, comunicação), com "dados" circulando pelas
// ligações. Desenhado em SVG (nítido em qualquer tela); a animação respeita
// "reduzir movimento" do sistema (ver .login-ilus-dado em App.css).

const CX = 300, CY = 250;
const NOS = [
  { x: 300, y: 62, rotulo: 'Integração com sistemas', icone: 'sync' },
  { x: 500, y: 150, rotulo: 'Captação', icone: 'funil' },
  { x: 500, y: 352, rotulo: 'Indicadores', icone: 'grafico' },
  { x: 300, y: 438, rotulo: 'Comunicação', icone: 'chat' },
  { x: 100, y: 352, rotulo: 'Equipes', icone: 'equipe' },
  { x: 100, y: 150, rotulo: 'Pacientes', icone: 'coracao' },
];

function Icone({ tipo }) {
  const p = { fill: 'none', stroke: '#fff', strokeWidth: 2.2, strokeLinecap: 'round', strokeLinejoin: 'round' };
  switch (tipo) {
    case 'sync': return <g {...p}><path d="M-9 -2a9 9 0 0 1 15.5-5.5L9 -5" /><path d="M9 -11v6h-6" /><path d="M9 2a9 9 0 0 1-15.5 5.5L-9 5" /><path d="M-9 11v-6h6" /></g>;
    case 'funil': return <g {...p}><path d="M-10 -9h20l-7.5 9v8l-5 3v-11z" /></g>;
    case 'grafico': return <g {...p}><path d="M-10 9h20" /><path d="M-6 5v-5" /><path d="M0 5v-11" /><path d="M6 5v-7" /></g>;
    case 'chat': return <g {...p}><path d="M-10 -8h20v12h-11l-6 5v-5h-3z" /><path d="M-5 -2h10" /></g>;
    case 'equipe': return <g {...p}><circle cx="-5" cy="-4" r="3.5" /><circle cx="6" cy="-3" r="3" /><path d="M-12 9c0-5 3-8 7-8s7 3 7 8" /><path d="M4 2c4 0 7 2 7 6" /></g>;
    case 'coracao': return <g {...p}><path d="M0 9s-10-6-10-12a5.5 5.5 0 0 1 10-3 5.5 5.5 0 0 1 10 3c0 6-10 12-10 12z" /><path d="M-5 -1h3l2-3 2 6 2-3h3" /></g>;
    default: return null;
  }
}

export default function LoginIlustracao() {
  return (
    <svg className="login-ilus" viewBox="0 0 600 500" role="img" aria-label="O Quality conecta integração com sistemas, captação, pacientes, equipes, indicadores e comunicação">
      <defs>
        <radialGradient id="li-brilho" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.28" />
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* anéis de fundo */}
      <circle cx={CX} cy={CY} r="215" fill="none" stroke="#ffffff" strokeOpacity="0.08" />
      <circle cx={CX} cy={CY} r="150" fill="none" stroke="#ffffff" strokeOpacity="0.1" strokeDasharray="3 7" />
      <circle cx={CX} cy={CY} r="120" fill="url(#li-brilho)" />

      {/* ligações + dados circulando */}
      {NOS.map((n, i) => {
        const d = `M${CX},${CY} L${n.x},${n.y}`;
        const volta = `M${n.x},${n.y} L${CX},${CY}`;
        return (
          <g key={`l${i}`}>
            <path d={d} stroke="#ffffff" strokeOpacity="0.35" strokeWidth="1.6" strokeDasharray="5 6" fill="none" />
            <circle className="login-ilus-dado" r="4" fill="#bff3e4">
              <animateMotion dur={`${2.6 + (i % 3) * 0.5}s`} repeatCount="indefinite" begin={`${i * 0.4}s`} path={d} />
            </circle>
            <circle className="login-ilus-dado" r="3" fill="#ffd27a">
              <animateMotion dur={`${3.2 + (i % 2) * 0.6}s`} repeatCount="indefinite" begin={`${1 + i * 0.3}s`} path={volta} />
            </circle>
          </g>
        );
      })}

      {/* módulos */}
      {NOS.map((n, i) => (
        <g key={`n${i}`} transform={`translate(${n.x},${n.y})`}>
          <circle r="30" fill="#ffffff" fillOpacity="0.14" stroke="#ffffff" strokeOpacity="0.55" strokeWidth="1.5" />
          <Icone tipo={n.icone} />
          <text y="50" textAnchor="middle" fill="#ffffff" fontSize="14" fontWeight="600" fontFamily="system-ui, -apple-system, Segoe UI, sans-serif">{n.rotulo}</text>
        </g>
      ))}

      {/* centro: o Q do Quality */}
      <g transform={`translate(${CX},${CY})`}>
        <rect x="-46" y="-46" width="92" height="92" rx="24" fill="#ffffff" />
        <g fill="none" stroke="#42796e" strokeWidth="9" strokeLinecap="round">
          <path d="M3 22.5a22 22 0 1 1 18.5-17.5" />
          <path d="M6 7l18 18" />
        </g>
      </g>
    </svg>
  );
}
